import "core-js/es6/map";
import "core-js/es6/set";
import "babel-polyfill";
import "es6-promise/auto";
import React from "react";
import { render } from "react-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import App from "./components/App";
import rootReducer from "./reducers";
// import "bootstrap/dist/css/bootstrap.min.css";

const store = createStore(
  rootReducer,
  { mType: "" },
  window.devToolsExtension && window.devToolsExtension()
);

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js